import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface EventRsvpTicketConfirmationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm?: () => void
}

export function EventRsvpTicketConfirmationModal({ open, setOpen, onConfirm }: EventRsvpTicketConfirmationModalProps) {
	const handleCancel = () => {
		setOpen(false)
	}

	const handleConfirm = () => {
		onConfirm?.()
		setOpen(false)
	}

	return (
		<ConfirmationModal title="RSVP" open={open} setOpen={setOpen} hideCloseButton={false}>
			<div>
				<div className="mb-8">This event requires at least one ticket type. Would you like to create one?</div>
				<div className="flex flex-col justify-between gap-3">
					<Button variant="primary" fullWidth onClick={handleConfirm}>
						Yes
					</Button>
					<Button variant="secondary" fullWidth onClick={handleCancel}>
						No
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface EventRsvpTicketConfirmationModalManagedProps {
	onConfirm?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'event-rsvp-ticket-confirmation': EventRsvpTicketConfirmationModalManagedProps
	}
}

export function ManagedEventRsvpTicketConfirmationModal({
	onClose,
	onConfirm,
}: EventRsvpTicketConfirmationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<EventRsvpTicketConfirmationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm?.(); handleClose() }}
		/>
	)
}
